import "./assets/scss/style.scss";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import MainNavigation from "./components/navigation/MainNavigation";
import { NavProvider } from "./context/NavContext";
import { ProfileProvider } from "./context/ProfileContext";
import { ConfigProvider } from "antd";
import { antdTheme, themeMui } from "./components/styled/Theme";
import { ThemeProvider } from "@mui/material";
import { GlobalProvider } from "./context/GlobalContext";
// import { IdleTimerProvider } from "./context/IdleTimerContext";

const App = () => {
  return (
    <ThemeProvider theme={themeMui}>
      <ConfigProvider theme={antdTheme}>
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          toastOptions={{
            duration: 4000,
            success: {
              style: {
                background: "green",
                color: "white",
                fontSize: 14,
              },
            },
            error: {
              style: {
                background: "red",
                color: "white",
                fontSize: 14,
              },
            },
          }}
        />
        <GlobalProvider>
          <BrowserRouter>
            <AuthProvider>
              {/* <IdleTimerProvider> */}
              <ProfileProvider>
                <NavProvider>
                  <MainNavigation />
                </NavProvider>
              </ProfileProvider>
              {/* </IdleTimerProvider> */}
            </AuthProvider>
          </BrowserRouter>
        </GlobalProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default App;
